export class Search {
  page?: number;
  size?: number;
  distinct?: boolean = true;
  sorts?: [
    {
      direction?: 'ASC' | 'DESC';
      property?: string;
      nullHandling?: 'NATIVE' | 'NULLS_FIRST' | 'NULLS_LAST';
    },
  ];
  fetches?: [];
  accountId?: number;
  contratId?: string;
}

export class SearchResponse {
  totalElements?: number;
  totalPages?: number;
  first?: boolean;
  last?: boolean;
  sort?: {
    sorted?: boolean;
    empty?: boolean;
    unsorted?: boolean;
  };
  pageable?: {
    sort?: {
      sorted?: boolean;
      empty?: boolean;
      unsorted?: boolean;
    };
    pageNumber?: number;
    pageSize?: number;
    offset?: number;
    paged?: boolean;
    unpaged?: boolean;
  };
  size?: number;
  content?: any;
  number?: number;
  numberOfElements?: number;
  empty?: boolean;
}
